module.exports = __webpack_public_path__ + "static/cynthia-del-rio-9813593cc577a319a2201342ef0fb237.jpg";